import { useAppSelector } from '../../reducers';
import { planBuilderCheckoutProductConfigurationsSelector, planBuilderHasCommonTermsSelector } from '../../selectors/PlanBuilderSelectors';
import { commonPurchaseMotionsSelector, talkToSalesTypeSelector } from '../../selectors/PurchaseMotionSelectors';
export const usePlanBuilderPurchaseMotions = () => {
  const checkoutProductConfigurations = useAppSelector(planBuilderCheckoutProductConfigurationsSelector);
  const talkToSalesType = useAppSelector(talkToSalesTypeSelector);
  const hasCommonTerms = useAppSelector(planBuilderHasCommonTermsSelector);
  const purchaseMotions = useAppSelector(state => {
    const skuIdsToUse = checkoutProductConfigurations.map(({
      skuId
    }) => skuId);
    const commonPurchaseMotions = commonPurchaseMotionsSelector(state, {
      skuIds: skuIdsToUse,
      location: 'CALCULATOR'
    });

    // Some non-exhaustive examples of why we check for common terms:
    // 1. HSFX-eligible products and starter products don't have any common terms,
    // so we cannot send them to checkout touchlessly.
    // 2. Seats customers on MCMP won't have any common terms between Starter and Pro
    // products either.
    if (!hasCommonTerms) {
      const filteredPurchaseMotions = commonPurchaseMotions.filter(purchaseMotion => purchaseMotion !== 'BUY_TOUCHLESS');
      if (!filteredPurchaseMotions.length) {
        return [talkToSalesType];
      }
      return filteredPurchaseMotions;
    }
    return commonPurchaseMotions;
  });

  // public purchase motions are always 1 button unless trial exist in the array, then show all the buttons
  if (purchaseMotions.includes('TRIAL')) return purchaseMotions;
  if (purchaseMotions.includes('BUY_TOUCHLESS')) return ['BUY_TOUCHLESS'];
  return [talkToSalesType];
};
export default usePlanBuilderPurchaseMotions;